import styled from 'styled-components'
export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden !important;
  padding-top: 30px;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    overflow: scroll;
  }
  .rex {
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      padding: 0px 30px;
      display: flex;
      justify-content: space-between;
    }
  }
  .step {
    display: flex;
    align-items: center;
    padding-left: 70px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      padding-left: 0px;
    }
    .details {
      padding-left: 10px;
    }

    p {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 20px;
      color: ${({ theme }) => theme.colors.CardDark};
      margin-top: -13px;
    }
    .step-topic {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      color: #292d32;
    }
  }
  .back {
    padding: 50px 100px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: ${({ theme }) => theme.colors.secondPrimary};
    cursor: pointer;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      padding: 50px 0px;
    }
  }
`

export const ForgotWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -150px;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    margin-top: -50px;
  }
  .welcome {
    text-align: center;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      text-align: left;
      align-self: flex-start;
      padding-left: 40px;
    }

    h1 {
      font-style: normal;
      font-weight: 600;
      font-size: 24px;
      line-height: 29px;
      letter-spacing: 0.2px;
      color: #333333;
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        font-size: 24px;
      }
    }
    p {
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      color: ${({ theme }) => theme.colors.CardDark};
      margin-bottom: 50px;
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        margin-top: -10px;
        margin-bottom: 40px;
        font-size: 14px;
      }
    }
  }
`

export const FormWrapper = styled.form`
  width: 40%;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 80%;
    margin-bottom: 300px;
  }
  .each-form {
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .to-left {
      float: right;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      color: ${({ theme }) => theme.colors.secondPrimary};
    }
  }

  label {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.DarkCyan};
    padding-bottom: 10px;
  }
`
export const PasswordContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  .img {
    position: absolute;
    right: 18px;
    cursor: pointer;
    font-size: 20px;
  }
`
